import { Component, OnInit } from '@angular/core';
import { FormBuilder} from '@angular/forms';

import { NotificationService, PayoutService } from '../../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({ templateUrl: './payout-upload.component.html' })
export class PayoutUploadComponent implements OnInit {

  fileUploading = false;

  uploadResultUrl = '';

  source = 7;
  sourceName = 'PAY365';
  country = "TH";
  countryName = "Thailand";

  constructor(private fb: FormBuilder,
    private payoutSvc: PayoutService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {

  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  uploadedFile: File = null;

  onFileChange(event){
     if(event != null && event.target != null && event.target.files != null && event.target.files.length > 0){
       this.uploadedFile = event.target.files[0];
     }else{
       this.uploadedFile = null;
     }
  }

  uploadPayoutRecords() {
    if(this.uploadedFile == null){
      this.notification.showWarning("Pls select file first", "Upload Result");
      return;
    }
    this.uploadResultUrl = '';
    this.fileUploading = true;
    var data = new FormData();
    data.append("file", this.uploadedFile, this.uploadedFile.name);
    data.append("country", this.country);
    data.append("source", "" + this.source);
    this.payoutSvc.uploadRecords(data)
      .subscribe(res => {
        this.fileUploading = false;
        if(res != null && res.status == 1){
          this.uploadResultUrl = res.data;
          document.getElementById('uploadResultBtn').click();
        }else{
          this.notification.showError(res.msg, "Upload Record Result");
        };
      });
  }

}
